import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTable} from "primeng/primeng";
import {ProjectService} from "@catcore/services";
import {TestRackSetupService} from "@catmodules/models/test-rack/services/test-rack-setup.service";
import {isNullOrUndefined} from "util";
import {DatatableExportService} from "@catcore/services/datatable-export.service";
import {BreadcrumbService} from "@catmodules/widgets/breadcrumb/services/breadcrumb.service";

@Component({
  selector: 'catapp-patch-field-links',
  templateUrl: './patch-field-links.component.html',
  styleUrls: ['./patch-field-links.component.scss']
})
export class PatchFieldLinksComponent implements OnInit {

  project = null;
  testRackSetup = null;
  projectSubscription = null;
  testRackName = '';

  hasUnassignedUnits = false;
  hasUnassignedPorts = false;

  @ViewChild('dt')
  dt: DataTable;

  private tableItemSource = [];
  tableItems = [];
  msgs = [];

  showUnassignedUnits = false;
  showUnassignedPorts = true;

  constructor(private projectService: ProjectService,
              private testRackSetupService: TestRackSetupService,
              private datatableExportService: DatatableExportService,
              private breadcrumbService: BreadcrumbService) { }

  setShowUnassignedUnits(value) {
    this.showUnassignedUnits = value;
    this.updateTableItems();
  }

  setShowUnassignedPorts(value) {
    this.showUnassignedPorts = value;
    if (!this.showUnassignedPorts) {
      this.showUnassignedUnits = false;
    }
    this.updateTableItems();
  }

  ngOnInit() {
    this.projectSubscription = this.projectService.getCurrentProject().subscribe((project) => {
      this.project = project;
      if (this.project !== null && this.project.id !== null) {
        const subscr = this.projectService.getTestRackSetups(this.project)
          .finally(() => {subscr.unsubscribe()})
          .subscribe((testRackSetups: any) => {
            if (testRackSetups.length > 0) {
              this.testRackSetup = testRackSetups[0];
              this.updateData();
            }
          });
      }
    });

    this.breadcrumbService.update([{label: 'Patch Field Links', value: 'testRackLinks' }]);
  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
  }

  exportToHtml() {
    this.datatableExportService.exportToHtml(this.dt, this.project.name + ' - ' + this.testRackName + ' Links');
  }

  exportToCsv($event) {
    this.dt.exportFilename = this.project.name + ' - ' + this.testRackName + ' Links';
    this.dt.exportCSV();
  }

  updateData() {
    if (this.testRackSetup) {
      this.testRackName = this.testRackSetup._links.test_rack.label;
      const subsc = this.testRackSetupService.getPatchFieldLinks(this.testRackSetup)
        .finally(() => { subsc.unsubscribe() })
        .subscribe((patchFieldLinks) => {
          this.createDataTableItems(patchFieldLinks);
        });
    }
  }

  createDataTableItems(patchFieldLinks) {
    this.msgs = [];
    this.hasUnassignedUnits = false;
    this.hasUnassignedPorts = false;
    patchFieldLinks.forEach((patchFieldLink) => {
      const data = {
        unit1: patchFieldLink.unit1,
        port1: patchFieldLink.port1,
        unitSlot1: patchFieldLink.unit_slot1 || '',
        outlet1: patchFieldLink.outlet1 || '',
        outlet2: patchFieldLink.outlet2 || '',
        unitSlot2: patchFieldLink.unit_slot2 || '',
        port2: patchFieldLink.port2,
        unit2: patchFieldLink.unit2,
        hasUnassignedUnit: (isNullOrUndefined(patchFieldLink.unit_slot1) || isNullOrUndefined(patchFieldLink.unit_slot2)),
        hasUnassignedPort: (isNullOrUndefined(patchFieldLink.outlet1) || isNullOrUndefined(patchFieldLink.outlet2)),
      };
      if (data.hasUnassignedUnit) {
        this.hasUnassignedUnits = true;
      }
      if (data.hasUnassignedPort) {
        this.hasUnassignedPorts = true;
      }
      this.tableItemSource = [...this.tableItemSource, data];
    });
    this.updateTableItems();
    if (this.hasUnassignedUnits) {
      this.msgs = [...this.msgs, {
        severity: 'warn',
        summary: 'Unassigned units',
        detail: 'Not all connected units could be assigned to a test rack slot'
      }];
    }
    if (this.hasUnassignedPorts) {
      this.msgs = [...this.msgs, {
        severity: 'warn',
        summary: 'Unassigned ports',
        detail: 'Not all connected ports have an outlet on the patch field'
      }];
    }
  }

  updateTableItems() {
    this.tableItems = [];
    this.tableItemSource.forEach((item) => {
      if ((this.showUnassignedUnits || !item.hasUnassignedUnit)
          && (this.showUnassignedPorts || !item.hasUnassignedPort)) {
        this.tableItems = [...this.tableItems, item];
      }
    });
    this.dt.reset();
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/test-rack/components/patch-field-links/patch-field-links.component.ts